import { NgModule } from '@angular/core';
import { ExtraOptions, PreloadAllModules, ResolveFn, RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from './error-page/error-page.component';
import { isAppInitialized } from '@core/bootstrap/bootstrap.guard';
import { RsvpCanActivateFn } from '@app/rsvp/rsvp.guard';
import { ErrorPaths } from './route-list.const';

const rsvpModule = () => import('./rsvp/rsvp.module').then((x) => x.RsvpModule);
const venueModule = () => import('./venue/venue.module').then((x) => x.VenueModule);

const checkoutChildRoutes: Routes = [
  { path: '', loadChildren: venueModule },
  { path: 'rsvp/:id', loadChildren: rsvpModule, canActivate: [RsvpCanActivateFn] }
];

const previousUrlResolver: ResolveFn<string> = () => {
  // Used for logging the original URL. Fall back in case window can't be safely accessed
  try {
    return window.location.href;
  } catch {
    return '';
  }
};

const errorRoutes = ErrorPaths.map((path) => ({
  path,
  component: ErrorPageComponent,
  resolve: {
    url: previousUrlResolver
  }
}));

const routes: Routes = [
  ...errorRoutes,
  {
    path: ':slug/:lang',
    data: { routeHasVenueSlug: false },
    canActivate: [isAppInitialized],
    children: checkoutChildRoutes
  },
  {
    path: ':venue/:slug/:lang',
    data: { routeHasVenueSlug: true },
    canActivate: [isAppInitialized],
    children: checkoutChildRoutes
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

const options: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, options)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
